import { colors } from '@lmc/common/constants'
import type React from 'react'
import type { ChangeEventHandler } from 'react'
import { FormInput as OldFormInput } from '../../../LEGACY/elemental'
import 'cleave.js/dist/addons/cleave-phone.gb'
import Cleave from 'cleave.js/react'
import AnimateHeight from 'react-animate-height'
import styled from 'styled-components'

type FormInputProps = {
  className?: string
  disabled?: boolean
  error?: string
  format?: boolean
  inputStyle?: object
  onChange: ChangeEventHandler<HTMLInputElement>
  options?: object
  placeholder?: string
  readOnly?: boolean
  style?: object
  type?: string
  value?: string | number
}

export default function FormInput({
  className,
  disabled,
  error,
  format,
  inputStyle = {},
  onChange,
  options,
  placeholder,
  style,
  type,
  value,
  ...inputProps
}: FormInputProps) {
  const dynamicStyle: React.CSSProperties = {
    height: '40px',
    width: '100%',
    borderColor: error ? colors.red : undefined,
    background: disabled ? '#fafafa' : '',
    pointerEvents: disabled ? 'none' : 'auto',
    ...inputStyle,
    opacity: disabled ? 0.39 : 1
  }

  return (
    <div style={style}>
      {format ? (
        // @ts-ignore
        <StyledCleave
          className={className}
          onChange={!disabled ? (e) => onChange(e) : undefined}
          options={options as any}
          placeholder={placeholder || ''}
          style={dynamicStyle}
          value={value ?? ''}
          {...inputProps}
        />
      ) : (
        <StyledOldFormInput
          className={className}
          onChange={
            !disabled
              ? (e: React.ChangeEvent<HTMLInputElement>) => onChange(e)
              : undefined
          }
          placeholder={placeholder || ''}
          style={dynamicStyle}
          type={type}
          value={value ?? ''}
          {...inputProps}
        />
      )}
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <ErrorText>{error}</ErrorText>
      </AnimateHeight>
    </div>
  )
}

const ErrorText = styled.div`
  color: ${colors.red};
  font-size: 11px;
  padding-top: 5px;
`

const StyledCleave = styled(Cleave)`
  appearance: none;
  background-color: white;
  border-color: ${colors.grey};
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  color: inherit;
  display: block;
  height: 40px;
  line-height: 2.3em;
  padding: 0 0.75em;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  width: 100%;

  &:hover {
    border-color: ${colors.primary};
    outline: 0;
  }

  &:focus {
    border-color: ${colors.primary};
    outline: 0;
  }
`

const StyledOldFormInput = styled(OldFormInput)`
  height: 40px;
  width: 100%;
`
